import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Proveedor } from './proveedor.model';

@Injectable()
export class ProveedorResolver implements Resolve<Proveedor> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Proveedor);
      }
      return await this.backendService.get(Proveedor, Proveedor.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/proveedores']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/proveedor/proveedor.resolver.ts